"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var connections;
        (function (connections) {
            var index;
            (function (index_1) {
                let SharePointAuthType;
                (function (SharePointAuthType) {
                    SharePointAuthType["UserAccount"] = "UserAccount";
                    SharePointAuthType["AppOnlyPrincipal"] = "AppOnlyPrincipal";
                })(SharePointAuthType || (SharePointAuthType = {}));
                class InitArgs {
                    constructor() {
                        this.oAuth2Box = appn.emptyString;
                        this.oAuth2Dropbox = appn.emptyString;
                        this.oAuth2Egnyte = appn.emptyString;
                        this.oAuth2GeoOp = appn.emptyString;
                        this.oAuth2Google = appn.emptyString;
                        this.oAuth2Microsoft = appn.emptyString;
                        this.oAuth2MicrosoftGraph = appn.emptyString;
                        this.oAuth2PowerBi = appn.emptyString;
                        this.oAuth2Salesforce = appn.emptyString;
                        this.oAuth2NetSuite = appn.emptyString;
                        this.oAuth2Snowflake = appn.emptyString;
                        this.oAuth2Xero = appn.emptyString;
                        this.oAuth2Rest = appn.emptyString;
                        this.oAuth2ArcGis = appn.emptyString;
                        this.oAuth2QuickBooksOnline = appn.emptyString;
                        this.connectionsValidateXXXConnection = appn.emptyString;
                        this.googleAccessTokenUrl = appn.emptyString;
                        this.initPicker = false;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    if (appn.utils.getUrlParamByName('showCon'))
                        $('#addConnection').click();
                    if (_initArgs.initPicker) {
                        setTimeout(() => {
                            gapi.client.load('drive', 'v2');
                            gapi.load('picker', () => { });
                        }, 1000);
                    }
                    addEvents();
                    initKeyValueTables();
                    $('.connection-card').each(function () {
                        ajaxValidateConnection($(this));
                    });
                    appn.select.init();
                }
                index_1.init = init;
                function addEvents() {
                    $('.connectorOption').on('click', function () {
                        if ($(this).data('upgrade-required')) {
                            $('#upgradeReqd').modal('show');
                            return;
                        }
                        if ($(this).data('gf-required')) {
                            $('#upgradeGFReqd').modal('show');
                            return;
                        }
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="' + $(this).attr('id') + '" />');
                        form.validate().cancelSubmit = true;
                        form.submit();
                    });
                    $('.btn-clone-connect').on('click', function (event) {
                        if ($(this).data('gf-required')) {
                            event.preventDefault();
                            $('#upgradeGFReqd').modal('show');
                        }
                    });
                    $('.editSecretKey').click(function (event) {
                        event.preventDefault();
                        const connectionCard = $(this).closest('.connection-card');
                        connectionCard.find('.maskedSecretKey').hide();
                        connectionCard.find('.editSecretKey').hide();
                        connectionCard.find('.input-secretkey').fadeIn();
                    });
                    $(document).on('click', '.buildIcon', function (e) {
                        e.preventDefault();
                        const formulaBox = $(this).closest('div.input-group-sm').find('input');
                        appn.ui.formulabuilder.currentFormula = formulaBox.val();
                        appn.ui.formulabuilder.currentMode = $(this).data('type');
                        appn.ui.formulabuilder.requiresDesignerJson = false;
                        appn.ui.formulabuilder.formulaUpdated = function (formula) {
                            formulaBox.val(formula);
                            formulaBox.trigger('change');
                            formulaBox.trigger('keyup');
                        };
                        appn.ui.formulabuilder.showDialog();
                    });
                    addAwsEvents();
                    addBoxEvents();
                    addDropboxEvents();
                    addEgnyteEvents();
                    addGeoOpEvents();
                    addGoogleEvents();
                    addMicrosoftEvents();
                    addPowerBiEvents();
                    addSalesforceEvents();
                    addSharePointEvents();
                    addNetSuiteEvents();
                    addSnowflakeEvents();
                    addXeroEvents();
                    addMicrosoftGraphEvents();
                    addFtpEvents();
                    addRestEvents();
                    addArcGisEvents();
                    addQuickBooksOnlineEvents();
                    $('.btnTryAddConnector').off().on('click', function (event) {
                        event.preventDefault();
                        $('#addConnection').click();
                    });
                    $(document).find('.show-copy-sql-dialog-integration').off().on('click', function (event) {
                        event.preventDefault();
                        const buttonConfig = {
                            copy: {
                                label: T('COPY SQL') + ' <i class="fa fa-copy"></i>',
                                className: 'btn-warning',
                                callback: function (result) {
                                    if (result) {
                                        const copyText = document.getElementsByClassName('show-copy-sql-dialog-integration-msg')[0];
                                        copyText.select();
                                        document.execCommand('copy');
                                    }
                                }
                            }
                        };
                        const text = `CREATE SECURITY INTEGRATION YOUR_INTEGRATION_NAME
    ENABLED = TRUE
    TYPE = OAUTH
    OAUTH_CLIENT = CUSTOM
    OAUTH_CLIENT_TYPE = 'CONFIDENTIAL'
    OAUTH_ISSUE_REFRESH_TOKENS = TRUE
    OAUTH_REDIRECT_URI = '${$(this).closest('.card').find('div[class$="callback-url"]').text().trim()}'`;
                        const msg = appn.elementBuilder.createElement('textarea', 'form-control form-control-sm show-copy-sql-dialog-integration-msg', undefined, [['rows', '10'], ['readonly', '']], text, true);
                        appn.dialog.custom({
                            modalColor: 'modal-info',
                            title: T('Copy Integration Commands'),
                            message: msg,
                            className: '',
                            closeButton: true,
                            buttons: buttonConfig
                        });
                    });
                    $(document).find('.show-copy-sql-dialog-authentication').off().on('click', function (event) {
                        event.preventDefault();
                        const buttonConfig = {
                            copy: {
                                label: '<span>' + T('COPY SQL') + '</span><i class="fa fa-copy"></i>',
                                className: 'btn-warning',
                                callback: function (result) {
                                    if (result) {
                                        const copyText = document.getElementsByClassName('show-copy-sql-dialog-authentication-msg')[0];
                                        copyText.select();
                                        document.execCommand('copy');
                                    }
                                }
                            }
                        };
                        const text = `SELECT SYSTEM$SHOW_OAUTH_CLIENT_SECRETS( 'YOUR_INTEGRATION_NAME' );`;
                        const msg = appn.elementBuilder.createElement('textarea', 'form-control form-control-sm show-copy-sql-dialog-authentication-msg', undefined, [['rows', '2'], ['readonly', '']], text, true);
                        appn.dialog.custom({
                            modalColor: 'modal-info',
                            title: T('Copy Authentication Commands'),
                            message: msg,
                            className: '',
                            closeButton: true,
                            buttons: buttonConfig
                        });
                    });
                    $('.btn-google-picker').on('click', function (e) {
                        e.preventDefault();
                        const connection = $(this).closest('.connection-card');
                        const connectionId = connection.data('connection-id');
                        const pickerId = connection.find('[id$="_PickerId"]');
                        const pickerName = connection.find('.google-picker-name');
                        const pickerBtn = connection.find('.btn-google-picker');
                        const isSharedFile = connection.find('[id$="_IsSharedDriveFolder"]');
                        $.ajax({
                            headers: appn.verifyHeader,
                            url: _initArgs.googleAccessTokenUrl,
                            type: 'POST',
                            data: { connId: connectionId },
                            success: function (data, status, xhttp) {
                                const response = JSON.parse(data);
                                var view = new google.picker.DocsView()
                                    .setIncludeFolders(true)
                                    .setMimeTypes('application/vnd.google-apps.folder')
                                    .setSelectFolderEnabled(true);
                                this.picker = new google.picker.PickerBuilder()
                                    .setAppId(response.ClientId)
                                    .setOAuthToken(response.accessToken)
                                    .setTitle("Choose Folder")
                                    .addView(view)
                                    .setCallback(function (data) {
                                    if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
                                        var file = data[google.picker.Response.DOCUMENTS][0];
                                        var id = file[google.picker.Document.ID];
                                        const isShared = file.isShared;
                                        pickerId.val(id);
                                        pickerName.val(file.name);
                                        if (isShared)
                                            isSharedFile.val(isShared);
                                    }
                                })
                                    .build()
                                    .setVisible(true);
                            },
                            error: function (data, message, message2) {
                                appn.toast.notify(appn.toast.Type.error, T('Could not fetch access token.'));
                            }
                        });
                    });
                }
                function initKeyValueTables() {
                    $(document).on('click', '.kv-table-add-item', function (event) {
                        event.preventDefault();
                        const kvTableId = '#' + $(this).data('kvTableId');
                        const kvTable = $(kvTableId);
                        const propName = kvTable.data('kvPropName');
                        const isSecretsEnabled = kvTable.data('kvEnableSecrets');
                        const isBuilderEnabled = kvTable.data('kvEnableBuilder');
                        const propId = propName.replaceAll('.', '_');
                        const kvTableBody = kvTable.find('.kv-table-body');
                        const index = kvTableBody.find('tr.kv-table-indexed-row').length;
                        const keyColumn = `<td class="dataCol"><input type="text" class="form-control form-control-sm valid" name="${propName}[${index}].Key"></td>`;
                        const valueColumn = isBuilderEnabled
                            ? `<td class="dataCol"><div class="input-group-sm input-group"><input type="text" class="form-control" autocomplete="off" name="${propName}[${index}].Val"/><div class="input-group-append"><button class="fa fa-hammer btn-sm btn btn btn-secondary buildIcon" data-type="text" type="button"><i></i></button></div></div></td>`
                            : `<td class="dataCol"><input type="text" class="form-control form-control-sm" autocomplete="off" name="${propName}[${index}].Val"></td>`;
                        const secretColumn = isSecretsEnabled
                            ? `<td class="dataCol">${appn.elementBuilder.buildCheckbox('', 'isSecretCheckbox', `${propId}[${index}]_IsSecret`, appn.elementBuilder.ICheckColor.primary, `${propName}[${index}].IsSecret`, true, false)}</td>`
                            : appn.emptyString;
                        const closeColumn = `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow('kv-table-remove-item')}</td>`;
                        kvTableBody.append(`<tr class="kv-table-indexed-row" data-kv-table-row-idx="${index}">${keyColumn}${valueColumn}${secretColumn}${closeColumn}</tr>`);
                        kvTable.showElement();
                        if (isSecretsEnabled)
                            appn.ui.checkboxForceOnChanged('.isSecretCheckbox');
                    });
                    $(document).on('click', '.kv-table-remove-item', function () {
                        const kvTable = $(this).closest('.kv-table');
                        const kvTableBody = kvTable.find('.kv-table-body');
                        const propName = kvTable.data('kvPropName');
                        const propId = propName.replaceAll('.', '_');
                        $(this).closest('tr').remove();
                        kvTableBody.find('tr.kv-table-indexed-row').each(function (index) {
                            const row = $(this);
                            const previousIdx = row.data('kvTableRowIdx');
                            if (previousIdx != index) {
                                row.find(`[name='${propName}[${previousIdx}].Key']`).attr('name', `${propName}[${index}].Key`);
                                row.find(`[data-valmsg-for='${propName}[${previousIdx}].Key']`).attr('data-valmsg-for', `${propName}[${index}].Key`);
                                row.find(`[name='${propName}[${previousIdx}].Val']`).attr('name', `${propName}[${index}].Val`);
                                row.find(`[name='${propName}[${previousIdx}].IsSecret']`).attr('name', `${propName}[${index}].IsSecret`);
                                row.find(`[id='${propId}[${previousIdx}]_IsSecret']`).attr('id', `${propId}[${index}]_IsSecret`);
                                row.find(`[for='${propId}[${previousIdx}]_IsSecret']`).attr('for', `${propId}[${index}]_IsSecret`);
                                row.attr('data-kv-table-row-idx', index);
                                row.data('kvTableRowIdx', index);
                            }
                        });
                    });
                }
                function clearCloseAndSubmitForm(window, win, pollTimer) {
                    window.clearInterval(pollTimer);
                    win.close();
                    $('form#appnForm').submit();
                }
                function transformAndBuildQueryString(connectorName) {
                    return appn.location.buildQueryString([
                        { name: 'returnAction', value: `${connectorName}Callback` },
                        { name: 'returnController', value: 'Connections' },
                        { name: 'returnState', value: `${appn.requestProvider.id}XXY` }
                    ]);
                }
                function addAwsEvents() {
                    $('.aws-region-select').off().on('change', function () {
                        const regionSelect = $(this);
                        const region = regionSelect.val();
                        const customEndpoint = regionSelect.parents('[data-type="AWS"]').find('.aws-custom-endpoint');
                        customEndpoint.toggleClass('d-none', region !== "CUSTOM_S3_ENDPOINT");
                    });
                }
                function addBoxEvents() {
                    $('.boxAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Box + transformAndBuildQueryString('Box');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=1024, height=640');
                        const pollTimer = window.setInterval(function () {
                            try {
                                if (win === null || win === undefined || win.document === undefined)
                                    window.clearInterval(pollTimer);
                                if (win && win.document.URL.containsIgnoreCase('Connections/BoxCallback'))
                                    clearCloseAndSubmitForm(window, win, pollTimer);
                            }
                            catch (error) { }
                        }, 500);
                    });
                }
                function addQuickBooksOnlineEvents() {
                    $('.quickBooksOnlineAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2QuickBooksOnline + transformAndBuildQueryString('QuickBooksOnline');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        const sandBox = $(this).closest('.connection-card').find('.isSandBox').prop('checked');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}%7c${sandBox}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=1024, height=640');
                        const pollTimer = window.setInterval(function () {
                            try {
                                if (!win || !win.document)
                                    window.clearInterval(pollTimer);
                                if (win && win.document.URL.containsIgnoreCase('Connections/QuickBooksOnlineCallback'))
                                    clearCloseAndSubmitForm(window, win, pollTimer);
                            }
                            catch (error) { }
                        }, 500);
                    });
                }
                function addDropboxEvents() {
                    $('.dropboxAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Dropbox + transformAndBuildQueryString('Dropbox');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=1024, height=640');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/DropboxCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                    $('.dropboxRevoke').on('click', function (event) {
                        event.preventDefault();
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="dropboxRevoke|' + connectionId + '" />');
                        form.submit();
                    });
                }
                function addEgnyteEvents() {
                    $('.egnyteAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Egnyte + transformAndBuildQueryString('Egnyte');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=1024, height=640');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/EgnyteCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                    $('.egnyteRevoke').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Egnyte + transformAndBuildQueryString('Egnyte');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=1024, height=640');
                        const pollTimer = window.setInterval(function () {
                            try {
                                if (win === null || win === undefined || win.document === undefined)
                                    window.clearInterval(pollTimer);
                                if (win && win.document.URL.containsIgnoreCase('Connections/EgnyteCallback'))
                                    clearCloseAndSubmitForm(window, win, pollTimer);
                            }
                            catch (error) { }
                        }, 500);
                    });
                }
                function addGeoOpEvents() {
                    $('.geoOpAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2GeoOp + transformAndBuildQueryString('GeoOp');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=640, height=480');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/GeoOpCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                    $('.geoOpRevoke').on('click', function (event) {
                        event.preventDefault();
                    });
                }
                function addGoogleEvents() {
                    $('.gAuth').on('click', function (event) {
                        event.preventDefault();
                        const conn = $(this).closest('.connection-card');
                        let url = _initArgs.oAuth2Google + transformAndBuildQueryString('Google');
                        const connectionId = conn.data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        if (conn.find('.restricted').length > 0) {
                            appn.dialog.custom({
                                modalColor: 'modal-info',
                                title: T('Change Legacy Connection'),
                                message: 'Are you sure you want to change this connection? <br/><br/>Legacy Google connection support has been discontinued and may cause existing connectors that use this connection to behave differently. <br/>We suggest creating a new Google connection and updating your connector configurations.',
                                closeButton: true,
                                buttons: {
                                    trash: {
                                        label: '<span>' + T('Re-authenticate') + '</span><i class="fa fa-check"></i>',
                                        className: 'btn-success',
                                        callback: function (result) {
                                            if (!result)
                                                return;
                                            launchGoogleAuthWindow(url);
                                        }
                                    }
                                }
                            });
                        }
                        else
                            launchGoogleAuthWindow(url);
                    });
                    function launchGoogleAuthWindow(url) {
                        const win = window.open(url, 'authwindow', 'width=640, height=670');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/GoogleCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    }
                    $('.gRevoke').on('click', function (event) {
                        event.preventDefault();
                        const url = 'https://accounts.google.com/b/0/IssuedAuthSubTokens';
                        window.open(url, 'authwindow', 'width=900, height=600');
                    });
                }
                function addMicrosoftEvents() {
                    $('.microsoftAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Microsoft + transformAndBuildQueryString('Microsoft');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=640, height=620');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/MicrosoftCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                    $('.microsoftRevoke').on('click', function (event) {
                        event.preventDefault();
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="microsoftRevoke|' + connectionId + '" />');
                        form.submit();
                    });
                }
                function addMicrosoftGraphEvents() {
                    $('.microsoftGraphAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2MicrosoftGraph + transformAndBuildQueryString('MicrosoftGraph');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=640, height=620');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/MicrosoftGraphCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                    $('.microsoftGraphRevoke').on('click', function (event) {
                        event.preventDefault();
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="microsoftGraphRevoke|' + connectionId + '" />');
                        form.submit();
                    });
                    $('.graphAuthType').on('change', function () {
                        $('form#appnForm').valid();
                    });
                }
                function addArcGisEvents() {
                    $('.arcGisAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2ArcGis + transformAndBuildQueryString('ArcGis');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=640, height=620');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/arcgiscallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                    $('.arcGisRevoke').on('click', function (event) {
                        event.preventDefault();
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="arcGisRevoke|' + connectionId + '" />');
                        form.submit();
                    });
                    $('.arcGisAuthType').on('change', function () {
                        $('form#appnForm').valid();
                        const arcGisConn = $(this).closest('#arcGisConn');
                        arcGisConn.find('.authButton').addClass('d-none');
                        if ($(this).val() == "Public") {
                            arcGisConn.find('.arcgisclientid').addClass('d-none');
                            arcGisConn.find('.arcgisclientsecret').addClass('d-none');
                            arcGisConn.find('.arcgiscallback').addClass('d-none');
                            arcGisConn.find('.arcgiskey').addClass('d-none');
                            arcGisConn.find('.arcgisclientid input').val(appn.emptyString);
                            arcGisConn.find('.arcgisclientsecret input').val(appn.emptyString);
                            arcGisConn.closest('.arcgiskey input').val(appn.emptyString);
                        }
                        else if ($(this).val() == "ApiKey") {
                            arcGisConn.find('.arcgisclientid').addClass('d-none');
                            arcGisConn.find('.arcgisclientsecret').addClass('d-none');
                            arcGisConn.find('.arcgiscallback').addClass('d-none');
                            arcGisConn.find('.arcgiskey').removeClass('d-none');
                            arcGisConn.find('.arcgisclientid input').val(appn.emptyString);
                            arcGisConn.find('.arcgisclientsecret input').val(appn.emptyString);
                        }
                        else if ($(this).val() == "User") {
                            arcGisConn.find('.arcgiskey').addClass('d-none');
                            arcGisConn.find('.arcgisclientid').addClass('d-none');
                            arcGisConn.find('.arcgisclientsecret').addClass('d-none');
                            arcGisConn.find('.arcgiscallback').removeClass('d-none');
                            arcGisConn.find('.arcgisclientid input').val(appn.emptyString);
                            arcGisConn.find('.arcgisclientsecret input').val(appn.emptyString);
                            arcGisConn.closest('.arcgiskey input').val(appn.emptyString);
                        }
                        else if ($(this).val() == "App") {
                            $(this).closest('#arcGisConn').find('.arcgiscallback').addClass('d-none');
                            $(this).closest('#arcGisConn').find('.arcgiskey').addClass('d-none');
                            $(this).closest('#arcGisConn').find('.arcgisclientid').removeClass('d-none');
                            $(this).closest('#arcGisConn').find('.arcgisclientsecret').removeClass('d-none');
                            arcGisConn.closest('.arcgiskey input').val(appn.emptyString);
                        }
                    });
                }
                function addPowerBiEvents() {
                    $('.powerBIAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2PowerBi + transformAndBuildQueryString('PowerBI');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=640, height=670');
                        const pollTimer = window.setInterval(function () {
                            if (!win)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/PowerBICallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                }
                function addNetSuiteEvents() {
                    $('.netSuiteAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2NetSuite + transformAndBuildQueryString('NetSuite');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=1024, height=640');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/NetSuiteCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                }
                function addSalesforceEvents() {
                    $('.salesforceAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Salesforce + transformAndBuildQueryString('Salesforce');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=1024, height=640');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/SalesforceCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                }
                function addSharePointEvents() {
                    $('.spAuthType').off().on('change', function () {
                        const current = $(this);
                        const parentConn = current.parents('[data-type="SharePoint"]');
                        const authType = current.val();
                        if (authType === SharePointAuthType.AppOnlyPrincipal) {
                            parentConn.find('.spUserAccount').addClass('d-none');
                            parentConn.find('.spAppOnlyPrincipal').removeClass('d-none');
                        }
                        else {
                            parentConn.find('.spUserAccount').removeClass('d-none');
                            parentConn.find('.spAppOnlyPrincipal').addClass('d-none');
                        }
                    });
                }
                function addSnowflakeEvents() {
                    $('.snowflakeAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Snowflake + transformAndBuildQueryString('Snowflake');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=1024, height=640');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/SnowflakeCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                    $('.snowflakeAuthMethod').off().on('change', function () {
                        const current = $(this);
                        const parentConn = current.parents('[data-type="Snowflake"]');
                        const authMethod = current.val();
                        if (authMethod === 'KeyPair' || authMethod === '1') {
                            parentConn.find('.snowflake-oauth-section').addClass('d-none');
                            parentConn.find('.snowflake-keypair-section').removeClass('d-none');
                        }
                        else {
                            parentConn.find('.snowflake-oauth-section').removeClass('d-none');
                            parentConn.find('.snowflake-keypair-section').addClass('d-none');
                        }
                        $('form#appnForm').valid();
                    });
                    $('.snowflakeAuthMethod').trigger('change');
                }
                function addXeroEvents() {
                    $('.xeroAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Xero + transformAndBuildQueryString('Xero');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=600, height=862');
                        const pollTimer = window.setInterval(function () {
                            try {
                                if (win === null || win === undefined || win.document === undefined)
                                    window.clearInterval(pollTimer);
                                if (win && win.document.URL.containsIgnoreCase('Connections/XeroCallback'))
                                    clearCloseAndSubmitForm(window, win, pollTimer);
                            }
                            catch (error) { }
                        }, 500);
                    });
                }
                function addFtpEvents() {
                    $('.ftp-ftp-encryption').on('change', function () {
                        const ftpEncryption = $(this).val();
                        const anyCertContainer = $(this).parents('[data-type="FTP"]').find('.ftp-validate-any-certificate-container');
                        if (ftpEncryption === 'ExplicitSSL')
                            anyCertContainer.removeClass('d-none');
                        else
                            anyCertContainer.addClass('d-none');
                    });
                }
                function addRestEvents() {
                    function showHideBodyRequest(conn) {
                        const dataType = conn.find('select[id$="Request_Format"]').val();
                        const httpVerb = conn.find('select[id$="Request_Verb"]').val();
                        const body = conn.find('.request-body');
                        if (httpVerb === 'Get') {
                            body.val(appn.emptyString);
                            body.hideElement();
                            return;
                        }
                        if (dataType === 'Xml' || dataType === 'Json') {
                            body.showElement();
                            return;
                        }
                        body.val(appn.emptyString);
                        body.hideElement();
                    }
                    function showHideFormData(conn) {
                        const dataType = conn.find('select[id$="Request_Format"]').val();
                        const dataValues = conn.find('.formData-request');
                        if (dataType === 'UrlEncoded') {
                            dataValues.showElement();
                            return;
                        }
                        dataValues.hideElement();
                    }
                    $('.restAuth').on('click', function (event) {
                        event.preventDefault();
                        let url = _initArgs.oAuth2Rest + transformAndBuildQueryString('Rest');
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        if (connectionId)
                            url = url.replace('XXY', `%7c${connectionId}`);
                        else
                            url = url.replace('XXY', appn.emptyString);
                        const win = window.open(url, 'authwindow', 'width=640, height=620');
                        const pollTimer = window.setInterval(function () {
                            if (win === null || win === undefined)
                                window.clearInterval(pollTimer);
                            if (win && win.document.URL.containsIgnoreCase('Connections/RestCallback'))
                                clearCloseAndSubmitForm(window, win, pollTimer);
                        }, 500);
                    });
                    $('.restRevoke').on('click', function (event) {
                        event.preventDefault();
                        const connectionId = $(this).closest('.connection-card').data('connection-id');
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="restRevoke|' + connectionId + '" />');
                        form.submit();
                    });
                    $(document).on('click', '.btnRestAddOauth', function (event) {
                        event.preventDefault();
                        const conn = $(this).closest('.connection-card');
                        conn.find('.rest-oauth-group,.btnRestRemoveOauth').showElement();
                        conn.find('.btnRestAddOauth').hideElement();
                        conn.find('.btnRestAddAuthRequest').hideElement();
                        conn.find('input[id$="AuthUrl"]').rules('add', { required: true });
                        conn.find('input[id$="TokenUrl"]').rules('add', { required: true });
                    });
                    $(document).on('click', '.btnRestRemoveOauth', function (event) {
                        event.preventDefault();
                        const conn = $(this).closest('.connection-card');
                        conn.find('.rest-oauth-group,.btnRestRemoveOauth').hideElement();
                        conn.find('.btnRestAddOauth,.btnRestAddAuthRequest').showElement();
                        conn.find('input[id$="AuthUrl"], input[id$="TokenUrl"]').val(appn.emptyString);
                        conn.find('input[id$="AuthUrl"]').rules('remove', 'required');
                        conn.find('input[id$="TokenUrl"]').rules('remove', 'required');
                    });
                    $(document).on('click', '.btnRestAddAuthRequest', function (event) {
                        event.preventDefault();
                        const conn = $(this).closest('.connection-card');
                        conn.find('.restAuthRequestContainer,.btnRestRemoveAuthRequest').showElement();
                        conn.find('.btnRestAddAuthRequest,.btnRestAddOauth').hideElement();
                        showHideFormData(conn);
                        showHideBodyRequest(conn);
                        conn.find('textarea[id$="AuthRequest_Url"]').rules('add', { required: true });
                    });
                    $(document).on('click', '.btnRestRemoveAuthRequest', function (event) {
                        event.preventDefault();
                        const conn = $(this).closest('.connection-card');
                        conn.find('.btnRestAddAuthRequest,.btnRestAddOauth').showElement();
                        conn.find('.restAuthRequestContainer,.btnRestRemoveAuthRequest').hideElement();
                        conn.find('textarea[id$="AuthRequest_Url"]').val(appn.emptyString);
                        conn.find('textarea[id$="AuthRequest_Url"]').rules('remove', 'required');
                    });
                    $(document).on('change', '.connection-card[data-type="REST"] .httpVerb', function (event) {
                        event.preventDefault();
                        const conn = $(this).closest('.connection-card');
                        showHideBodyRequest(conn);
                    });
                    $(document).on('change', '.connection-card[data-type="REST"] .formatType', function (event) {
                        event.preventDefault();
                        const conn = $(this).closest('.connection-card');
                        showHideBodyRequest(conn);
                        showHideFormData(conn);
                    });
                }
                function connectionCheck(connectionCard) {
                    const label = connectionCard.find('.statusLabel');
                    const icon = connectionCard.find('.statusIcon');
                    const details = connectionCard.find('.accountDetails');
                    const cardTools = connectionCard.find('.card-tools');
                    icon.html(appn.ui.getSpinner());
                    label.html(T('Checking Connection...'));
                    details.hide();
                    cardTools.prepend(appn.ui.getSpinner('spinner-border-sm'));
                    connectionCard.find('.statusBox').fadeIn();
                }
                function connectionSuccess(connectionCard, info) {
                    const label = connectionCard.find('.statusLabel');
                    const icon = connectionCard.find('.statusIcon');
                    const details = connectionCard.find('.accountDetails');
                    const cardTools = connectionCard.find('.card-tools');
                    const statusBox = connectionCard.find('.statusBox');
                    const statusDetails = connectionCard.find('.statusDetails');
                    const cardBody = connectionCard.find('.statusBox .card-body');
                    const cardBodyText = connectionCard.find('.statusBox .card-body .statusLabel');
                    cardBodyText.addClass('text-success');
                    icon.html('<i class="fa fa-check mr-2"></i>' + T('Connected'));
                    label.remove();
                    icon.addClass('text-success');
                    cardTools.find('.appn-spinner').remove();
                    cardTools.prepend(`<span class="small"><i class="fa fa-check text-success"></i>&nbsp;${T('Connected')}</span>`);
                    if (info !== undefined && info !== null) {
                        details.show();
                        $.each(info, function (key, value) {
                            if (key.contains('Css')) {
                                const target = connectionCard.find('.' + key.replace('Css', appn.emptyString));
                                const vals = value.split(':');
                                target.css(vals[0], value.replace(vals[0] + ':', appn.emptyString));
                            }
                            else if (key.contains('Attr')) {
                                const target = connectionCard.find('.' + key.replace('Attr', appn.emptyString));
                                const vals = value.split(':');
                                target.attr(vals[0], value.replace(vals[0] + ':', appn.emptyString));
                            }
                            else {
                                const target = connectionCard.find('.' + key);
                                target.html(value);
                            }
                        });
                    }
                    else
                        details.hide();
                    if (statusDetails.is(':empty'))
                        cardBody.hide();
                    connectionCard.find('.statusBox').fadeIn();
                }
                function connectionError(connectionCard, errm) {
                    const label = connectionCard.find('.statusLabel');
                    const icon = connectionCard.find('.statusIcon');
                    const details = connectionCard.find('.accountDetails');
                    const cardTools = connectionCard.find('.card-tools');
                    const statusBox = connectionCard.find('.statusBox');
                    const statusDetails = connectionCard.find('.statusDetails');
                    const cardBody = connectionCard.find('.statusBox .card-body');
                    const cardBodyText = connectionCard.find('.statusBox .card-body .statusLabel');
                    icon.html(`<i class="fa fa-exclamation-triangle mr-2"></i>${T('Error')}`);
                    cardTools.find('.appn-spinner').remove();
                    icon.addClass('text-danger');
                    cardBodyText.addClass('text-danger');
                    cardTools.prepend(`<span class=""><i class="fa fa-times text-danger"></i>&nbsp;${T('Cannot Connect')}</span>`);
                    if (errm !== null && errm !== undefined && errm.length > 0)
                        label.text(errm);
                    else
                        label.text('Cannot Connect');
                    details.hide();
                    if (statusDetails.is(':empty') && label.is(':empty'))
                        cardBody.hide();
                    connectionCard.find('.statusBox').fadeIn();
                }
                function ajaxValidateConnection(connectionCard, dataCallback) {
                    connectionCheck(connectionCard);
                    const url = _initArgs.connectionsValidateXXXConnection.replace('XXX', String(connectionCard.data('type')));
                    appn.ajax.post({
                        url: url,
                        data: { id: appn.requestProvider.id, connectionId: String(connectionCard.data('connection-id')) },
                        dataType: 'json',
                        done: function (data) {
                            if (data && data.Valid && data.Valid === true) {
                                connectionSuccess(connectionCard, data.AccountInfo);
                                if (dataCallback)
                                    dataCallback(data);
                                return;
                            }
                            connectionError(connectionCard, data.ErrorMessage);
                            if (dataCallback)
                                dataCallback(data);
                        },
                        fail: function (data) {
                            connectionError(connectionCard, data.statusText);
                            if (dataCallback)
                                dataCallback(data);
                        }
                    });
                }
            })(index = connections.index || (connections.index = {}));
        })(connections = views.connections || (views.connections = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
